<ui-dialog
    *ngIf="paidPayrolls.length"
    formDialog
    #filterModal
    [form]="vacationYTDBalancesReportFilterForm.form"
    size="small"
    [open]="displayVacationYTDBalancesReportFilterModal"
    header="reporting.payroll.filterResults"
    [primaryButtonLabel]="'save'"
    (primaryButtonPressed)="
        onFilter(vacationYTDBalancesReportFilterForm.dates, vacationYTDBalancesReportFilterForm.payPeriodName)
    "
    [secondaryButtonLabel]="'cancel'"
    (secondaryButtonPressed)="hideOrDisplayVacationYTDBalancesReportFilterModal(false)"
    (closing)="hideOrDisplayVacationYTDBalancesReportFilterModal(false)"
>
    <app-form-filter-payroll-report
        [schedule]="schedule"
        [report]="vacationBalancesReport"
        [reportStartAt]="startAt"
        [reportEndAt]="endAt"
        [displayPayPeriodName]="true"
        [showAllTimeOption]="true"
        initialFilter="allTime"
        #vacationYTDBalancesReportFilterForm
    ></app-form-filter-payroll-report>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <div class="flex align-items-center">
        <app-header
            [title]="'reporting.payroll.vacationBalances.name'"
            [back]="true"
            [backRoute]="'/reporting/payroll'"
        ></app-header>
        <div class="flex align-items-center justify-end">
            <ui-button
                *ngIf="paidPayrolls.length"
                class="margin-left-1"
                (click)="hideOrDisplayVacationYTDBalancesReportFilterModal(true)"
                type="outline"
                >{{ 'filter' | translate }}</ui-button
            >
            <ui-button class="margin-left-1" type="primary" [matMenu]="exportMenu">
                {{ 'export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('pdf')">PDF</button>
                <button mat-menu-item (click)="onExport('xlxs')">Excel</button>
                <button mat-menu-item (click)="onExport('csv')">CSV</button>
            </mat-menu>
        </div>
    </div>
    <div *ngIf="paidPayrolls.length && vacationBalancesReport?.additionalReportFields" class="margin-bottom-3">
        <p class="margin-bottom-1">
            {{ 'reporting.payroll.dateRange' | translate }}:
            <span
                *ngIf="
                    vacationBalancesReport?.additionalReportFields?.startDate &&
                        vacationBalancesReport?.additionalReportFields?.endDate;
                    else displayDash
                "
            >
                <span *ngIf="payPeriodName.length; else displayDateRange"> {{ payPeriodName | translate }} </span>
                <ng-template #displayDateRange>
                    <span>
                        {{ vacationBalancesReport.additionalReportFields?.startDate | date: 'longDate' }} -
                        {{ vacationBalancesReport.additionalReportFields.endDate | date: 'longDate' }}
                    </span>
                </ng-template>
            </span>
        </p>
        <p>
            {{ 'reporting.payroll.vacationBalances.units' | translate }}
            <span> {{ 'reporting.payroll.vacationBalances.currency' | translate }} </span>
        </p>
    </div>

    <div class="margin-bottom-3">
        <ui-tip>{{ 'reporting.payroll.vacationBalances.tooltip' | translate }}</ui-tip>
    </div>

    <ui-card>
        <div
            *ngIf="
                paidPayrolls.length &&
                    vacationBalancesReport?.sheet?.rows.length &&
                    vacationBalancesReport?.additionalReportFields;
                else displayNoVacationBalancesReports
            "
        >
            <table class="ui table">
                <thead>
                    <tr>
                        <th
                            *ngFor="let heading of vacationBalancesReport.sheet?.columns; let index = index"
                            class="top-sticky"
                        >
                            {{ heading.title }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of vacationBalancesReport.sheet.rows">
                        <td *ngFor="let cell of row.cells">
                            <span *ngIf="cell.value; else displayDash"> {{ cell.value }} </span>
                            <ng-template #displayDash>
                                <span>-</span>
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-template #displayNoVacationBalancesReports>
            <app-empty-state
                [label]="'reporting.payroll.vacationBalances.noDate'"
                src="/assets/illustrations/documents.png"
            ></app-empty-state>
        </ng-template>
    </ui-card>
</div>

<ng-template #displayDash>
    <span>-</span>
</ng-template>
